// Components
export { CheckoutButton } from './components/CheckoutButton';
export { PricingTable } from './components/PricingTable';
export { PaymentForm } from './components/PaymentForm';

// Backward compatibility alias
export { PaymentForm as CheckoutForm } from './components/PaymentForm';
export {
  MobilePaymentSheet,
  type MobilePaymentSheetProps,
} from './components/MobilePaymentSheet';
export {
  NativeSubscriptionView,
  type NativeSubscriptionViewProps,
} from './components/NativeSubscriptionView';
export {
  TouchIDPayment,
  type TouchIDPaymentProps,
} from './components/TouchIDPayment';

// Providers
export { StripeProvider } from './providers/StripeProvider';

// React Providers and Hooks (client-side only - native-specific versions)
// Note: These are native-specific implementations that use server-side APIs
// instead of the Node.js Stripe SDK to avoid bundling Node.js dependencies
export {
  PaymentsProvider,
  usePaymentsContext,
} from './providers/PaymentsProvider';
export { usePayments } from './hooks/usePayments';

// Native-specific hooks
export { useSubscription } from './hooks/useSubscription';
export { useCheckout } from './hooks/useCheckout';
export { useCustomer } from './hooks/useCustomer';

// Backward compatibility alias
export { useCheckout as useStripe } from './hooks/useCheckout';

// Analytics hooks (when available)
// export { useSubscriptionAnalytics } from '../shared/hooks/useSubscriptionAnalytics';
// export { useRevenueAnalytics } from '../shared/hooks/useRevenueAnalytics';

// Utils
export * from './utils/stripe-native';
